"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.StyledSubtitle = exports.StyledTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTitle = styled_components_1.default.div `
  font-weight: 600;
  font-size: 16px;
  line-height: 19.09px;
  color: #3E4555;
  text-align: center;
`;
exports.StyledSubtitle = styled_components_1.default.div `
  font-weight: 400;
  font-size: 14px;
  line-height: 16.71px;
  color: #657089;
  text-align: center;
  margin-bottom: 24px;
`;
exports.Wrapper = styled_components_1.default.div `
  height: fit-content;
  width: 100%;
  margin-bottom: 32px;
`;
//# sourceMappingURL=styled.js.map